

import { fetchPublicDataForInvoice } from "../../../../../services/apiServiceDashboard";

export default async function CustomerInvoiceTemplate(
  orderDetails = {},
  invoiceSettings = {},
  orderId,
  items = []
) {
  let publicData = {};
  try {
    publicData = await fetchPublicDataForInvoice();
    console.log("📞 بيانات الشركة المسترجعة:", publicData);
  } catch (err) {
    console.error("❌ فشل في جلب البيانات العامة:", err);
  }

  const address = publicData?.address || "";
  const phone = publicData?.phone || "";

  // ✅ تحويل الوقت 24h إلى 12h
  const convertTo12Hour = (timeString) => {
    if (!timeString) return "-";
    const [hours, minutes] = timeString.split(":");
    let h = parseInt(hours, 10);
    const period = h >= 12 ? "م" : "ص";
    if (h > 12) h -= 12;
    if (h === 0) h = 12;
    return `${String(h).padStart(2, "0")}:${minutes} ${period}`;
  };
  const kitchenName =
  orderDetails?._kitchen_name ||
  items?.[0]?.kitchen_name ||
  "-";
    const getOrderTypeLabel = (type) => {
      switch (type) {
        case "tables":
          return "صالة";
        case "takeaway":
          return "تيك أواي";
        case "delivery":
          return "دليفري";
        default:
          return type || "-";
      }
    };

    const orderTypeLabel = getOrderTypeLabel(orderDetails?.order_type);


  return `
    <!DOCTYPE html>
    <html dir="rtl">
    <head>
      <meta charset="UTF-8">
      <title>طباعة التجهيز</title>

      <style>
        @page {
          size: 80mm auto;
          margin: 0;
        }

        html, body {
          margin: 0;
          padding: 0;
          height: auto;
          background: #fff;
        }

        .receipt {
          font-family: Arial, sans-serif;
          width: 80mm;
          height: auto;
          padding: 6px;
          margin: 0;
          font-size: 12px;
          color: #000;
          direction: rtl;
          text-align: right;
          box-sizing: border-box;
        }

        h2 {
          margin: 4px 0;
          text-align: center;
          font-size: 15px;
          font-weight: bold;
        }

        h3 {
          margin: 4px 0;
          font-size: 12px;
          font-weight: bold;
        }

        p {
          margin: 2px 0;
          font-size: 11px;
        }

        hr {
          border: none;
          border-top: 1px dashed #000;
          margin: 4px 0;
        }

        /* ✅ جدول الأصناف */
        .items-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
        }

        .items-table th,
        .items-table td {
          border: 1px solid #000;
          padding: 3px;
          vertical-align: top;
        }

        .items-table th {
          background: #f2f2f2;
          font-weight: bold;
          font-size: 10px;
        }

        .product {
          width: 45%;
          word-break: break-word;
        }

        .qty {
          width: 15%;
          text-align: center;
          font-size: 13px;
          font-weight: bold;
        }

        .note {
          width: 40%;
          font-size: 10px;
          word-break: break-word;
        }

        .footer {
          text-align: center;
          margin-top: 6px;
          font-size: 10px;
        }

      </style>
    </head>

    <body>
      <div class="receipt">

        <h2>طباعة التجهيز</h2>
        <hr/>
        <p style="text-align:center; font-weight:bold; margin: 4px 0;">
  ${kitchenName} - ${orderTypeLabel}
      </p>


        <p><strong>رقم الطلب:</strong> ${orderDetails?.general_increment || "-"}</p>
        <p><strong>رقم الطلب اليومي:</strong> ${orderDetails?.daily_increment || "-"}</p>
        <p><strong>الزبون:</strong> ${orderDetails?.customer?.name || "-"}</p>
        <p><strong>الطاولة:</strong> ${orderDetails?.table?.name || "-"}</p>
        <p><strong>وقت الفتح:</strong> ${convertTo12Hour(orderDetails?.open_time)}</p>

        <hr/>

        <h3>الأصناف:</h3>

        <table class="items-table">
          <thead>
            <tr>
              <th>الصنف</th>
              <th style="text-align:center;">الكمية</th>
              <th>ملاحظة</th>
            </tr>
          </thead>
          <tbody>
            ${
              items && items.length > 0
                ? items.map(item => `
                    <tr>
                      <td class="product">${item.product_name || "-"}</td>
                      <td class="qty">${item.quantity || 0}</td>
                      <td class="note">${item.note || "-"}</td>
                    </tr>
                  `).join("")
                : `
                    <tr>
                      <td colspan="3" style="text-align:center;">
                        لا توجد أصناف
                      </td>
                    </tr>
                  `
            }
          </tbody>
        </table>

        <hr/>

        <div class="footer">
          <p>شكراً لكم</p>
          <p>تاريخ ووقت الطباعة: ${new Date().toLocaleString('ar-EG')}</p>
          ${address ? `<p>${address}</p>` : ""}
          ${phone ? `<p>${phone}</p>` : ""}
        </div>

      </div>
    </body>
    </html>
  `;
}
